import React, { useEffect, useState } from "react";
import "./DashboardCard.css";

// ── SVG Icons for each card category ──────────────────────────────────
function CardHeaderIcon({ iconType, color = "#fff" }) {
  const sw = "1.5";
  const r = "round";

  switch (iconType) {
    case "population":
      return (
        <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
          <circle cx="7" cy="6" r="2.5" stroke={color} strokeWidth={sw} />
          <path d="M2 16c0-2.76 2.24-5 5-5s5 2.24 5 5" stroke={color} strokeWidth={sw} strokeLinecap={r} />
          <circle cx="14" cy="7" r="1.8" stroke={color} strokeWidth="1.3" />
          <path d="M14 11.5c1.93 0 3.5 1.57 3.5 3.5" stroke={color} strokeWidth="1.3" strokeLinecap={r} />
        </svg>
      );
    case "loss":
      return (
        <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
          <path d="M10 2L2 17h16L10 2z" stroke={color} strokeWidth={sw} strokeLinejoin={r} />
          <path d="M10 8v4" stroke={color} strokeWidth="1.8" strokeLinecap={r} />
          <circle cx="10" cy="14.5" r="0.8" fill={color} />
        </svg>
      );
    case "boats":
      return (
        <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
          <path d="M3 13l2.5-5h9l2.5 5" stroke={color} strokeWidth={sw} strokeLinejoin={r} />
          <path d="M2 13c1.5 2 3.5 3 5.5 3s3-.8 5-3c1 1 2.5 3 5 3" stroke={color} strokeWidth={sw} strokeLinecap={r} strokeLinejoin={r} />
          <path d="M10 8V4M8 6h4" stroke={color} strokeWidth="1.3" strokeLinecap={r} />
        </svg>
      );
    case "relief":
      return (
        <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
          <rect x="3" y="7" width="14" height="10" rx="2" stroke={color} strokeWidth={sw} />
          <path d="M7 7V5a3 3 0 016 0v2" stroke={color} strokeWidth={sw} strokeLinecap={r} />
          <path d="M10 11v3M8.5 12.5h3" stroke={color} strokeWidth="1.5" strokeLinecap={r} />
        </svg>
      );
    case "facility":
      return (
        <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
          <rect x="3" y="4" width="14" height="13" rx="2" stroke={color} strokeWidth={sw} />
          <path d="M7 9h2v2H7zM11 9h2v2h-2zM7 13h2v4H7z" stroke={color} strokeWidth="1.2" strokeLinejoin={r} />
          <path d="M3 7h14" stroke={color} strokeWidth="1.2" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
          <circle cx="10" cy="10" r="7" stroke={color} strokeWidth={sw} />
          <path d="M10 6v4l2.5 2.5" stroke={color} strokeWidth="1.5" strokeLinecap={r} />
        </svg>
      );
  }
}

function MetricIcon({ label = "", color = "#fff" }) {
  const k = label.toLowerCase();
  const sw = "1.5";
  const r = "round";

  // -- BOATS --
  if (k.includes("motor"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M3 13l2-6h8l2 6" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><path d="M15 13c1 1 2 2 3 1" stroke={color} strokeWidth={sw} strokeLinecap={r}/><circle cx="15" cy="11" r="1.5" stroke={color} strokeWidth="1.2"/><path d="M2 16c2-1 3-1 5 0s3 1 5 0 3-1 5 0" stroke={color} strokeWidth="1.2" strokeLinecap={r}/></svg>;
  
  if (k.includes("private") || k.includes("govt"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M2 13l3-5h10l3 5" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><path d="M2 16c2.5-1.5 5.5-1.5 8 0s5.5 1.5 8 0" stroke={color} strokeWidth="1.2" strokeLinecap={r}/><path d="M10 8V3l4 2-4 2" stroke={color} strokeWidth={sw} strokeLinejoin={r}/></svg>;

  // -- RELIEF --
  if (k.includes("gr "))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><rect x="3" y="6" width="14" height="8" rx="2" stroke={color} strokeWidth={sw}/><circle cx="10" cy="10" r="2" stroke={color} strokeWidth={sw}/><path d="M3 10h2M15 10h2" stroke={color} strokeWidth="1.2"/></svg>;

  if (k.includes("ration"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><rect x="5" y="4" width="10" height="13" rx="1" stroke={color} strokeWidth={sw}/><path d="M5 8h10M8 4l-1-2h6l-1 2" stroke={color} strokeWidth="1.2" strokeLinecap={r}/><rect x="8" y="10" width="4" height="4" rx="1" stroke={color} strokeWidth="1.2"/></svg>;

  if (k.includes("sheet") || k.includes("polythene"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 14l5-9 7 3-5 9-7-3z" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><path d="M9 5l-2 5M12 6l-2 6" stroke={color} strokeWidth="1.2"/></svg>;

  // -- FACILITIES --
  if (k.includes("health"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><rect x="3" y="5" width="14" height="10" rx="2" stroke={color} strokeWidth={sw}/><path d="M10 7v6M7 10h6" stroke={color} strokeWidth={sw} strokeLinecap={r}/></svg>;

  if (k.includes("kitchen"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M5 10c0-3 2-6 5-6s5 3 5 6v4H5v-4z" stroke={color} strokeWidth={sw}/><path d="M3 14h14M8 14v3h4v-3M10 4V2" stroke={color} strokeWidth={sw} strokeLinecap={r}/></svg>;

  if (k.includes("camp"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M10 4L3 16h14L10 4z" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><path d="M10 4l2 12M10 16v-4l-3 4" stroke={color} strokeWidth={sw} strokeLinejoin={r}/></svg>;

  if (k.includes("animal shelter"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M3 9l7-6 7 6v7H3V9z" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><circle cx="8" cy="12" r="1.5" fill={color}/><circle cx="12" cy="12" r="1.5" fill={color}/><path d="M10 14h.01" stroke={color} strokeWidth="2" strokeLinecap={r}/></svg>;

  // -- ANIMALS (Loss & Affected) --
  if (k.includes("animal"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="13" r="4" stroke={color} strokeWidth={sw}/><circle cx="6" cy="6" r="1.5" fill={color}/><circle cx="10" cy="4" r="1.5" fill={color}/><circle cx="14" cy="6" r="1.5" fill={color}/></svg>;

  // -- HUMAN LOSS --
  if (k.includes("human loss") || k.includes("death"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M6 16V8c0-2.2 1.8-4 4-4s4 1.8 4 4v8H6z" stroke={color} strokeWidth={sw}/><path d="M10 7v5M8 9.5h4M4 16h12" stroke={color} strokeWidth={sw} strokeLinecap={r}/></svg>;

  // -- POPULATION --
  if (k.includes("evacuated"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="8" cy="5" r="2" stroke={color} strokeWidth={sw}/><path d="M8 7v5l-2 4M8 12l2 4M5 9h4" stroke={color} strokeWidth={sw} strokeLinecap={r}/><path d="M13 10h4l-2-2M15 12l2-2" stroke={color} strokeWidth={sw} strokeLinecap={r} strokeLinejoin={r}/></svg>;

  if (k.includes("family") || k.includes("families"))
    return <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="7" cy="6" r="2" stroke={color} strokeWidth={sw}/><circle cx="13" cy="7" r="1.5" stroke={color} strokeWidth={sw}/><path d="M4 15c0-2 1.5-4 3-4s3 2 3 4" stroke={color} strokeWidth={sw} strokeLinecap={r}/><path d="M11 15c0-1.5 1-3 2-3s2 1.5 2 3" stroke={color} strokeWidth={sw} strokeLinecap={r}/></svg>;

  // Default: generic info dot / graph
  return (
    <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
      <circle cx="10" cy="6" r="2.5" stroke={color} strokeWidth={sw} />
      <path d="M4 16c0-2.76 2.69-5 6-5s6 2.24 6 5" stroke={color} strokeWidth={sw} strokeLinecap={r} />
    </svg>
  );
}

// ── Pastel palette for header icon bg ────────────────────────────────
const ICON_PALETTE = {
  population: { bg: "#EBF3FA", color: "#2A6591" },
  loss:     { bg: "#FFF1F1", color: "#D95555" },
  boats:    { bg: "#E8F7FB", color: "#1EA6B4" },
  relief:   { bg: "#F0F9F4", color: "#27A05A" },
  facility: { bg: "#F5F1FD", color: "#8B52D6" },
};

const PALETTE = [
  { bg: "#EBF4FF", color: "#3579D4" },
  { bg: "#FFF4EA", color: "#D4772A" },
  { bg: "#EEFAF3", color: "#27A05A" },
  { bg: "#FFF0F0", color: "#D95555" },
  { bg: "#F3EEFF", color: "#8B52D6" },
  { bg: "#E7FAFB", color: "#1EA6B4" },
  { bg: "#FFFAEB", color: "#C49A17" },
  { bg: "#FEF0F9", color: "#C93E9F" },
  { bg: "#EBF4FF", color: "#2A6591" },
];

export default function DashboardCard({
  data,
  config,
  clickedKey,
  setClickedKey,
  triggeredFunction,
}) {
  const [cardData, setCardData] = useState({});
  useEffect(() => {
    setCardData(data);
  }, [data]);

  const formatCardData = (value) => {
    if (typeof value === "string" && value.includes("(")) {
      const splitValue = value.split("(");
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
          {splitValue[0]} <span style={{ fontSize: "0.65em", opacity: 0.85, fontWeight: "600" }}>({splitValue[1]}</span>
        </span>
      );
    }
    return value;
  };

  const iconPalette = ICON_PALETTE[config.iconType] || ICON_PALETTE.population;

  return (
    <div className="flood-avd-group">
      <div className="flood-avd-group-title">
        <span className="flood-avd-group-icon" style={{ background: iconPalette.bg }}>
          <CardHeaderIcon iconType={config.iconType} color={iconPalette.color} />
        </span>
        {config.title}
      </div>
      <div className="flood-avd-group-cards">
        {config?.data.map((conf, index) => {
          const active = clickedKey === conf.key;
          const p = PALETTE[index % PALETTE.length];
          return (
            <div
              key={index}
              className={`flood-avd-pill ${active ? "flood-avd-pill--active" : ""}`}
              onClick={() => {
                setClickedKey(conf?.key);
                triggeredFunction(
                  conf?.label,
                  conf?.apiKey,
                  conf?.key,
                  conf?.apiKey2,
                  conf?.keyName
                );
              }}
            >
              <span className="flood-avd-pill-icon" style={{ background: p.bg }}>
                <MetricIcon label={conf.label} color={p.color} />
              </span>
              <div className="flood-avd-pill-info">
                <div className="flood-avd-pill-label">{conf.label}</div>
                <div className="flood-avd-pill-value">
                  {cardData && cardData[conf?.key]
                    ? formatCardData(cardData[conf?.key])
                    : 0}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
